import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody,ButtonGroup} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as TextManager from "../../../modules/languages/TextManager";
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import EditPrizeForm from './EditPrizeForm'
import Modal from '../../../components/Modal';
import {
    prize_open_update_form,
    prize_delete
} from '../../../redux/actions/PrizeActions';


const goalTypeArr = [ '', 'שבוע', 'שבועיים', 'חודש'];

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class PrizeTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            deals: [],
            selectedID: 0,
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20
        };
    }

    addStore = () => {
        const store = {id: 0, storeId: 0, storeName: '', soldNum: 0, goal: 0, prize: '', startDay: '', endDay: '', comment: ''};
        this.props.dispatch(prize_open_update_form(store));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    };

    editPrize = (prize) => {
        if (prize.id === this.state.selectedID && this.state.windowType === 2) {
            this.setState({selectedID: 0, windowType: 0});
        }
        else {
            this.props.dispatch(prize_open_update_form(prize));
            this.setState({selectedID: prize.id, windowType: 2, error: false});
        }
    };

    deletePrize = (prize) => {
        //abc
        http.postToServer(
            'prize/delete?id=' + prize.id,
            {},
            (response) => {
                this.props.dispatch(prize_delete(this.props.day, prize.id));
            },
            (response) => {
                console.log('error delete prize');
            }
        );

    };

    getRow(prize, index, isDelete) {
        return (

            <React.Fragment key={prize.id}>

                <tr key={prize.id}>

                    {isDelete && <td>
                        <Modal color='danger' title='Are you sure!'
                               approve={() => this.deletePrize(prize)}
                               message={'Delete Prize for ' + prize.storeName + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>}

                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                                onClick={() => this.editPrize(prize)}>{TextManager.getCurrentTextResource().Text.edit}</Button>
                    </td>

                    <td>{prize.endDay}</td>
                    <td>{prize.startDay}</td>
                    <td>{prize.prize}</td>
                    <td>{prize.goal}</td>
                    <td>{prize.soldNum}</td>
                    <td>{prize.city}</td>
                    <td>{prize.managerName}</td>
                    <td>{prize.storeName}</td>
                    <td>{prize.storeId}</td>

                    {/*isDelete && <td>{prize.managerName}</td>*/}

                </tr>

                {this.state.windowType === 2 && prize.id === this.state.selectedID &&
                <tr key={prize.id + 2000}>
                    <td colSpan="7">
                        <EditPrizeForm day={this.props.day} onClose={() => this.editPrize(prize)}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.props.searchValue === undefined || this.props.searchValue === null || this.props.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.props.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'number') {
                    if (parseInt(this.props.searchValue) === mr) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {

        const {rowsPerPage, page} = this.state;

        const isDelete = this.props.userData && this.props.userData.data.isAdmin;

        var isAdding = this.state.windowType === 2 && this.state.selectedID === 0;

        let dataTable = this.props.data.find(a => a.day === this.props.day).dataArr;

        if (this.props.searchValue !== '') {
            dataTable = dataTable.filter(this.filterDataBySearch)
        }

        if(this.props.managersFilter && this.props.managersFilter.length !== 0) {
            dataTable = dataTable.filter(e => this.props.managersFilter.includes(e.managerId));
        }

        let rows = dataTable.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((prize, index, isDelete) =>
            this.getRow(prize,index, isDelete)
        );

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>

                    <CardBody>
                        {/*isAdding &&
                            <EditPrizeForm onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                        */}

                        {/*!isAdding && <div className="card__title">
                            <h5 className="bold-text"
                                style={{float: 'right'}}>{TextManager.getCurrentTextResource().Text.stores}</h5>
                        </div>*/}


                        {!isAdding &&
                        <span>
                            <Table responsive className='table--bordered'>
                            <thead>
                            <tr>

                                {isDelete && <th>
                                    {/*<Button color='primary' size='sm'
                                             style={{padding: "0px 15px", margin: "0px"}}
                                             onClick={() => this.addStore()}>
                                        <FontAwesome name='plus-square' style={{marginLeft: "5px"}}/>
                                    </Button>*/}

                                </th>}

                                <th></th>
                                <th>תאריך סיום את המבצע</th>
                                <th>תאריך התחלת את המבצע</th>
                                <th>מה הפרס</th>
                                <th>יעד לשבוע</th>
                                <th>?כמה מכר</th>
                                <th>עיר</th>
                                <th>מנהל</th>
                                <th>{TextManager.getCurrentTextResource().Customers.storeName}</th>
                                <th>{TextManager.getCurrentTextResource().Customers.storeId}</th>
                                {/*isDelete && <th>שם מנהל</th>*/}

                                <th></th>


                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>
                                <Row>
                                    <Col md={6} sm={12} lg={6} xs={12}>
                                        <CustomPagination
                                            labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                            rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
                                            component="div"
                                            count={this.props.data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            backIconButtonProps={{
                                                'aria-label': 'Previous Page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'Next Page',
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} lg={6} xs={12}>
                                        <ButtonGroup className='btn-group--icons'
                                                     style={{marginTop: "10px", float: "right"}}>
                                            {/*<Button outline color='primary'
                                                    onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>*/}
                                            <Button outline color='primary'
                                                    onClick={() => this.props.back()}>Go Back</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                        </span>}

                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.prize.data,
        status: state.prize.status,
        utilsData: state.utilsData,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(PrizeTable))